import IconButton from 'components/common/IconButton/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ELEMENT from 'common/element';
import { Secret } from 'common/graphqlTypes';
import { RowObject } from './types';
import './styles.scss';

const buildOnClick = (showAlert: (messsage: string) => void, secretName: string) => () => {
  navigator.clipboard.writeText('${secret:' + secretName + '}');
  showAlert('Text Copied');
};

export type RowDataParam = {
  secret: Secret;
  showAlert: (messsage: string) => void;
  isWriteDisabled: boolean;
  doModifySecret: (secret: Secret) => void;
  doDeleteSecret: (secret: Secret) => void;
};

export const makeSecretRowData = ({ secret, showAlert, doModifySecret, doDeleteSecret }: RowDataParam): RowObject => ({
  name: <span onClick={buildOnClick(showAlert, secret.name)}>{secret.name}</span>,
  description: secret.description,
  maskedSecret: secret.maskedSecret,
  createDate: secret.createDate,
  author: secret.author,
  actions: (
    <div className="SecretsPage__Actions">
      <IconButton
        icon={<EditIcon />}
        tooltip="Edit Secret"
        className="SecretsPage__ActionButton SecretsPage__CreateButton"
        onClick={(): void => {
          doModifySecret(secret);
        }}
        testId={ELEMENT.modifySecretButton}
      />
      <IconButton
        icon={<DeleteIcon />}
        tooltip="Delete Secret"
        className="SecretsPage__ActionButton SecretsPage__DeleteButton"
        onClick={(): void => {
          doDeleteSecret(secret);
        }}
        testId={ELEMENT.deleteSecretButton}
      />
    </div>
  ),
});
